
import styles from "./button.module.css"
export default function Button(props){

    
    return(
<button onClick={props.onClick} className={styles.button} style={{height:props.height, width:props.width,background:props.background, color:props.color, fontSize:props.fontsize }}>{props.value}</button>
    )
}